export default "__VITE_ASSET__0a663d03__$_?nuxt_component=async__"